/* eslint-disable */
import schedule from '../public/data/schedule.json';

export default {
  // If you don't want to test, just comment the fakeTime field
  // fakeTime: new Date('2020-04-18 20:59:55'), // year, month, day, time
  notificationTitle: 'bitsxlaMarato 2025',
  notificationIcon: 'favicon.ico',
  baseTimeOffset: -60 * 60,
  hackathon_duration_hours: 41,
  schedule: schedule,
};
